
import {inherits} from 'ol/util.js';
import Control from 'ol/control/Control';

import olTools from '@/openlayers/ol_tools'

/**
 * Define a namespace for the application.
 */
var app = {};


/**
 * @constructor
 * @extends {module:ol/interaction/Pointer}
 */

// Create a button on Map UI
app.CenterPositionControl = function (opt_options)
{
    let options = opt_options || {};

    let button = document.createElement('button');
    button.innerHTML = 'C';
    button.title = 'Reset Map';

    let this_ = this;
    let handleCenterPosition = function ()
    {
        olTools.resetMapViewPort (this_.getMap());
    };

    button.addEventListener('click', handleCenterPosition, false);
    button.addEventListener('touchstart', handleCenterPosition, false);

    let element = document.createElement('div');
    element.className = 'position-center ol-unselectable ol-control';
    element.appendChild(button);

    Control.call(this, {
        element: element,
        target: options.target
    });

};
inherits( app.CenterPositionControl, Control );

export default { app }